export interface ParkResourceTypeAmenity {
  parkId: string;
  resourceTypeId: number;
  name: string;
  isActive: boolean;
  rank: number;
}
